<template>
  <Header></Header>
  <ResumeNav></ResumeNav>
  <div>
    <div class="container text-center">
      <h2>You shall not pass.</h2>
      <!-- <img class="icon__wizard" src="/img/icon-wizard.svg" /> -->
      <SvgIconWizard class="icon__wizard"></SvgIconWizard>
      <form class="contact__form" v-on:submit.prevent="validateBeforeSubmit">
        <div class="form__item">
          <label
            for="user_name"
            class="form__item__label"
            :class="{ 'input-focused': focus }"
            >Please Enter Password:</label
          >
          <input
            id="user_name"
            type="password"
            name="password"
            v-model.trim="password"
            class="form__item__input"
            required
            @focus="addParentClass"
            @blur="removeParentClass"
          />
        </div>
        <div class="text-danger" v-if="error">
          <p>Incorrect password.</p>
        </div>
        <button class="btn btn-primary" type="submit">Submit</button>
        <GoBack></GoBack>
      </form>
    </div>
  </div>
</template>

<script>
  import storageHelper from "storage-helper"
  import router from "@/router/index.js"
  import GoBack from "@/components/GoBack.vue"
  import SvgIconWizard from "@/components/svg/SvgIconWizard.vue"
  import ResumeNav from "@/components/resume/ResumeNav.vue"
  import Header from "@/components/Header.vue"
  export default {
    name: "NotFound",
    components: {
      GoBack,
      SvgIconWizard,
      ResumeNav,
      Header,
    },
    data() {
      return {
        error: null,
        password: null,
      }
    },
    methods: {
      validateBeforeSubmit() {
        if (this.password === "abcd1234$") {
          this.error = false
          storageHelper.setItem("user-password", this.password)
          router.push("/resume/projects")
        } else {
          this.error = true
        }
      },
    },
  }
</script>

<style lang="scss"></style>
